import { MenuItem } from './menu.model';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { environment } from '../../../../environments/environment';
import { RoleEnum } from '@xfeet-workspace/xfeet-entities/enums';

export const MENU: MenuItem[] = [
  /*{
    label: 'Main',
    isTitle: true
  },
  {
    label: 'Dashboard',
    icon: 'feather icon-home',
    link: '/dashboard'
  },*/
  {
    label: _('Utilisateurs'),
    isTitle: true,
    roles: [RoleEnum.SUPPORT, RoleEnum.COMMERCIAL]
  },
  {
    label: _('Clients'),
    link: 'member/customers',
    roles: [RoleEnum.SUPPORT, RoleEnum.COMMERCIAL]
  },
  {
    label: _('Recherche capsule'),
    link: 'member/capsule-search',
    roles: [RoleEnum.SUPPORT, RoleEnum.COMMERCIAL]
  },
  {
    label: _('Sociétés'),
    isTitle: true,
    roles: [RoleEnum.GESTION_ACTIVITE_SOCIETE, RoleEnum.GESTION_DISTRIBUTEUR, RoleEnum.GESTION_FABRICANT, RoleEnum.GESTION_PREPARATEUR]
  },
  {
    label: _('Distributeurs'),
    //icon: 'mdi mdi-cart',
    link: '/company/distributors',
    roles: [RoleEnum.GESTION_DISTRIBUTEUR]
  },
  {
    label: _('Fabricants'),
    //icon: 'mdi mdi-cart',
    link: '/company/manufacturers',
    roles: [RoleEnum.GESTION_FABRICANT]
  },
  {
    label: _('Préparateurs'),
    //icon: 'mdi mdi-package-down',
    link: '/company/orderpickers',
    roles: [RoleEnum.GESTION_PREPARATEUR]
  },
  /*{
    label: _('Livreurs'),
    //icon: 'mdi mdi-package-down',
    link: '/company/shippers',
    roles: [RoleEnum.GESTION_ACTIVITE_SOCIETE]
  },*/
  {
    label: _('Fournisseurs'),
    //icon: 'mdi mdi-package-down',
    link: '/company/suppliers',
    roles: [RoleEnum.GESTION_ACTIVITE_SOCIETE]
  },
  {
    label: _('Fabrications'),
    isTitle: true,
    roles: [RoleEnum.LOGISTIC_FABRICATION]
  },
  {
    label: _('Rapport de fabrications'),
    //icon: 'feather icon-file-text',
    link: '/comptability/report',
    roles: [RoleEnum.LOGISTIC_FABRICATION]
  },
  {
    label: _('Commandes'),
    isTitle: true,
    roles: [RoleEnum.LOGISTIC_COMMANDE]
  },
  {
    label: _('Rechercher'),
    link: '/orders',
    roles: [RoleEnum.LOGISTIC_COMMANDE]
  },
  {
    label: _('A expédier'),
    link: '/orders/pending',
    roles: [RoleEnum.LOGISTIC_COMMANDE]
  },
  {
    label: _('Expédiées'),
    link: '/orders/shipped',
    roles: [RoleEnum.LOGISTIC_COMMANDE]
  },
  {
    label: _('Recouvrements'),
    isTitle: true,
    roles: [RoleEnum.LOGISTIC_RECOUVREMENT]
  },
  {
    label: _('Gammes'),
    //icon: 'feather icon-file-text',
    link: '/recovering/product-lines',
    roles: [RoleEnum.LOGISTIC_RECOUVREMENT]
  },
  {
    label: _('Produits'),
    //icon: 'feather icon-file-text',
    link: '/recovering/products',
    roles: [RoleEnum.LOGISTIC_RECOUVREMENT]
  },
  {
    label: _('Thermoformage'),
    isTitle: true,
    roles: [RoleEnum.LOGISTIC_THERMOFORMAGE]
  },
  {
    label: _('Bases'),
    //icon: 'feather icon-file-text',
    link: '/thermoforming/bases',
    roles: [RoleEnum.LOGISTIC_THERMOFORMAGE]
  },
  {
    label: _('Semelles'),
    //icon: 'feather icon-file-text',
    link: '/thermoforming/insoles',
    roles: [RoleEnum.LOGISTIC_THERMOFORMAGE]
  },
  {
    label: _('Fraisage'),
    isTitle: true,
    roles: [RoleEnum.LOGISTIC_FRAISAGE]
  },
  {
    label: _('Mousses'),
    //icon: 'feather icon-file-text',
    link: '/eva-foam/products',
    roles: [RoleEnum.LOGISTIC_FRAISAGE]
  },
  {
    label: _('Duretés'),
    //icon: 'feather icon-file-text',
    link: '/eva-foam/shores',
    roles: [RoleEnum.LOGISTIC_FRAISAGE]
  },
  {
    label: _('Eléments'),
    //icon: 'feather icon-file-text',
    link: '/eva-foam/elements',
    roles: [RoleEnum.LOGISTIC_FRAISAGE]
  },
  {
    label: 'Jobs',
    isTitle: true,
    roles: [RoleEnum.SUPPORT]
  },
  {
    label: _('Liste'),
    link: '/job',
    roles: [RoleEnum.SUPPORT],
  },
  // {
  //   label: _('Reporting'),
  //   link: 'reporting',
  //   roles: [RoleEnum.GESTION_COMMERCIALE, RoleEnum.COMMERCIAL, RoleEnum.SUPPORT]
  // },

  /*{
    label: _('Stocks'),
    icon: 'feather icon-file-text',
    link: '/recovering/stocks',
  },*/
  ...(environment.production === false && environment.staging === false?
  [
  {
    label: 'Components',
    isTitle: true
  },
  {
    label: 'UI Kit',
    icon: 'feather icon-feather',
    subItems: [
      {
        label: 'Accordion',
        link: '/ui-components/accordion',
      },
      {
        label: 'Alerts',
        link: '/ui-components/alerts',
      },
      {
        label: 'Badges',
        link: '/ui-components/badges',
      },
      {
        label: 'Breadcrumbs',
        link: '/ui-components/breadcrumbs',
      },
      {
        label: 'Buttons',
        link: '/ui-components/buttons',
      },
      {
        label: 'Button group',
        link: '/ui-components/button-group',
      },
      {
        label: 'Cards',
        link: '/ui-components/cards',
      },
      {
        label: 'Carousel',
        link: '/ui-components/carousel',
      },
      {
        label: 'Collapse',
        link: '/ui-components/collapse',
      },
      {
        label: 'Datepicker',
        link: '/ui-components/datepicker',
      },
      {
        label: 'Dropdowns',
        link: '/ui-components/dropdowns',
      },
      {
        label: 'List group',
        link: '/ui-components/list-group',
      },
      {
        label: 'Media object',
        link: '/ui-components/media-object',
      },
      {
        label: 'Modal',
        link: '/ui-components/modal',
      },
      {
        label: 'Navs',
        link: '/ui-components/navs',
      },
      {
        label: 'Navbar',
        link: '/ui-components/navbar',
      },
      {
        label: 'Pagination',
        link: '/ui-components/pagination',
      },
      {
        label: 'Popovers',
        link: '/ui-components/popovers',
      },
      {
        label: 'Progress',
        link: '/ui-components/progress',
      },
      {
        label: 'Rating',
        link: '/ui-components/rating',
      },
      {
        label: 'Spinners',
        link: '/ui-components/spinners',
      },
      {
        label: 'Timepicker',
        link: '/ui-components/timepicker',
      },
      {
        label: 'Tooltips',
        link: '/ui-components/tooltips',
      },
      {
        label: 'Typeadhed',
        link: '/ui-components/typeahead',
      },
    ]
  },
  {
    label: 'Advanced UI',
    icon: 'feather icon-anchor',
    subItems: [
      {
        label: 'Cropper',
        link: '/advanced-ui/cropper',
      },
      {
        label: 'Owl carousel',
        link: '/advanced-ui/owl-carousel',
      },
      {
        label: 'Sweet alert',
        link: '/advanced-ui/sweet-alert',
      },
    ]
  },
  {
    label: 'Forms',
    icon: 'feather icon-file-text',
    subItems: [
      {
        label: 'Basic elements',
        link: '/form-elements/basic-elements'
      },
      {
        label: 'Advanced elements',
        subItems: [
          {
            label: 'Form validation',
            link: '/advanced-form-elements/form-validation'
          },
          {
            label: 'Input mask',
            link: '/advanced-form-elements/input-mask'
          },
          {
            label: 'Ng-select',
            link: '/advanced-form-elements/ng-select'
          },
          {
            label: 'Ngx-chips',
            link: '/advanced-form-elements/ngx-chips'
          },
          {
            label: 'Ngx-color-picker',
            link: '/advanced-form-elements/ngx-color-picker'
          },
          {
            label: 'Ngx-dropzone',
            link: '/advanced-form-elements/ngx-dropzone-wrapper'
          },
        ]
      },
      {
        label: 'Editors',
        link: '/form-elements/editors'
      },
    ]
  },
  {
    label: 'Charts & graphs',
    icon: 'feather icon-pie-chart',
    subItems: [
      {
        label: 'ApexCharts',
        link: '/charts-graphs/apexcharts',
      },
      {
        label: 'ChartJs',
        link: '/charts-graphs/chartjs',
      },
    ]
  },
  {
    label: 'Tables',
    icon: 'feather icon-layout',
    subItems: [
      {
        label: 'Basic tables',
        link: '/tables/basic-table',
      },
      {
        label: 'Data table',
        link: '/tables/data-table',
      },
      {
        label: 'Ngx-datatable',
        link: '/tables/ngx-datatable'
      }
    ]
  },
  {
    label: 'Icons',
    icon: 'feather icon-smile',
    subItems: [
      {
        label: 'Feather icons',
        link: '/icons/feather-icons',
      },
      {
        label: 'Mdi icons',
        link: '/icons/mdi-icons',
      }
    ]
  },
  {
    label: 'Pages',
    isTitle: true
  },
  {
    label: 'Special pages',
    icon: 'feather icon-book',
    subItems: [
      {
        label: 'Blank page',
        link: '/general/blank-page',
      },
      {
        label: 'Faq',
        link: '/general/faq',
      },
      {
        label: 'Invoice',
        link: '/general/invoice',
      },
      {
        label: 'Profile',
        link: '/general/profile',
      },
      {
        label: 'Pricing',
        link: '/general/pricing',
      },
      {
        label: 'Timeline',
        link: '/general/timeline',
      }
    ]
  },
  {
    label: 'Authentication',
    icon: 'feather icon-unlock',
    subItems: [
      {
        label: 'Login',
        link: '/auth/login',
      },
      {
        label: 'Register',
        link: '/auth/register',
      },
    ]
  },
  {
    label: 'Error',
    icon: 'feather icon-cloud-off',
    subItems: [
      {
        label: '404',
        link: '/error/404',
      },
      {
        label: '500',
        link: '/error/500',
      },
    ]
  },
  ] : [])
];
